import { render } from "./LoginPwd.vue?vue&type=template&id=ca419662"
import script from "./LoginPwd.vue?vue&type=script&lang=js"
export * from "./LoginPwd.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DevelopmentWork\\app\\JGJWork\\vue\\t3custom_2pos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__